export const marketsZips =
  "12207,87102,22314,18101,79101,30303,04330,78701,21202,59102,35203,58501,61701,02108,42101,03222,11201,14202,63701,52401,25301,28202,37402,60602,45202,44114,29201,43215,75201,35601,80202,50309,48226,52001,55802,54701,79901,07201,14901,16501,47708,58102,72701,86001,93721,46802,76102,46402,81501,49503,54301,82935,27401,29601,17101,06103,77002,25701,67501,46204,39201,32202,65101,60432,64801,64106,37902,33801,78040,89101,40507,72201,90012,40202,79401,31201,53703,78501,97501,38103,33130,53202,55401,59802,36602,36104,29405,37219,70112,23510,69101,73102,68102,91764,97801,19102,85004,15222,97204,62301,27601,57701,89501,23219,24011,14604,61201,61101,48601,84101,78205,92101,94102,31401,98101,71101,57104,46601,99201,01103,56303,63101,95202,13202,32301,62568,47807,75501,31794,43604,85701,74103,83301,28403,22601";

export const getMarketFromQuery = (zip, placeName, stateCode) => {
  return { zip, countryCode: "US", placeName, stateCode };
};

export const marketToZip = {
  "Springfield, MA": "01103",
  "Boston, MA": "02108",
  "Bristol, NH": "03222",
  "Augusta, ME": "04330",
  "Hartford, CT": "06103",
  "Elizabeth, NJ": "07201",
  "Brooklyn, NY": "11201",
  "Albany, NY": "12207",
  "Syracuse, NY": "13202",
  "Buffalo, NY": "14202",
  "Rochester, NY": "14604",
  "Elmira, NY": "14901",
  "Pittsburgh, PA": "15222",
  "Erie, PA": "16501",
  "Harrisburg, PA": "17101",
  "Allentown, PA": "18101",
  "Philadelphia, PA": "19102",
  "Baltimore, MD": "21202",
  "Alexandria, VA": "22314",
  "Winchester, VA": "22601",
  "Richmond, VA": "23219",
  "Norfolk, VA": "23510",
  "Roanoke, VA": "24011",
  "Charleston, WV": "25301",
  "Huntington, WV": "25701",
  "Greensboro, NC": "27401",
  "Raleigh, NC": "27601",
  "Charlotte, NC": "28202",
  "Wilmington, NC": "28403",
  "Columbia, SC": "29201",
  "N Charleston, SC": "29405",
  "Greenville, SC": "29601",
  "Atlanta, GA": "30303",
  "Macon, GA": "31201",
  "Savannah, GA": "31401",
  "Tifton, GA": "31794",
  "Jacksonville, FL": "32202",
  "Tallahassee, FL": "32301",
  "Miami, FL": "33130",
  "Lakeland, FL": "33801",
  "Birmingham, AL": "35203",
  "Decatur, AL": "35601",
  "Montgomery, AL": "36104",
  "Mobile, AL": "36602",
  "Nashville, TN": "37219",
  "Chattanooga, TN": "37402",
  "Knoxville, TN": "37902",
  "Memphis, TN": "38103",
  "Jackson, MS": "39201",
  "Louisville, KY": "40202",
  "Lexington, KY": "40507",
  "Bowling Green, KY": "42101",
  "Columbus, OH": "43215",
  "Toledo, OH": "43604",
  "Cleveland, OH": "44114",
  "Cincinnati, OH": "45202",
  "Indianapolis, IN": "46204",
  "Gary, IN": "46402",
  "South Bend, IN": "46601",
  "Ft Wayne, IN": "46802",
  "Evansville, IN": "47708",
  "Terre Haute, IN": "47807",
  "Detroit, MI": "48226",
  "Saginaw, MI": "48601",
  "Grand Rapids, MI": "49503",
  "Des Moines, IA": "50309",
  "Dubuque, IA": "52001",
  "Cedar Rapids, IA": "52401",
  "Milwaukee, WI": "53202",
  "Madison, WI": "53703",
  "Green Bay, WI": "54301",
  "Eau Claire, WI": "54701",
  "Minneapolis, MN": "55401",
  "Duluth, MN": "55802",
  "St Cloud, MN": "56303",
  "Sioux Falls, SD": "57104",
  "Rapid City, SD": "57701",
  "Fargo, ND": "58102",
  "Bismarck, ND": "58501",
  "Billings, MT": "59102",
  "Missoula, MT": "59802",
  "Joliet, IL": "60432",
  "Chicago, IL": "60602",
  "Rockford, IL": "61101",
  "Rock Island, IL": "61201",
  "Bloomington, IL": "61701",
  "Quincy, IL": "62301",
  "Taylorville, IL": "62568",
  "St Louis, MO": "63101",
  "Cape Girardeau, MO": "63701",
  "Kansas City, MO": "64106",
  "Joplin, MO": "64801",
  "Jefferson City, MO": "65101",
  "Hutchinson, KS": "67501",
  "Omaha, NE": "68102",
  "North Platte, NE": "69101",
  "New Orleans, LA": "70112",
  "Shreveport, LA": "71101",
  "Little Rock, AR": "72201",
  "Fayetteville, AR": "72701",
  "Oklahoma City, OK": "73102",
  "Tulsa, OK": "74103",
  "Dallas, TX": "75201",
  "Texarkana, TX": "75501",
  "Ft Worth, TX": "76102",
  "Houston, TX": "77002",
  "Laredo, TX": "78040",
  "San Antonio, TX": "78205",
  "McAllen, TX": "78501",
  "Austin, TX": "78701",
  "Amarillo, TX": "79101",
  "Lubbock, TX": "79401",
  "El Paso, TX": "79901",
  "Denver, CO": "80202",
  "Grand Jct, CO": "81501",
  "Green River, WY": "82935",
  "Twin Falls, ID": "83301",
  "Salt Lake City, UT": "84101",
  "Phoenix, AZ": "85004",
  "Tucson, AZ": "85701",
  "Flagstaff, AZ": "86001",
  "Albuquerque, NM": "87102",
  "Las Vegas, NV": "89101",
  "Reno, NV": "89501",
  "Los Angeles, CA": "90012",
  "Ontario, CA": "91764",
  "San Diego, CA": "92101",
  "Fresno, CA": "93721",
  "San Francisco, CA": "94102",
  "Stockton, CA": "95202",
  "Portland, OR": "97204",
  "Medford, OR": "97501",
  "Pendleton, OR": "97801",
  "Seattle, WA": "98101",
  "Spokane, WA": "99201",
};
